









import { defineComponent, PropType } from 'vue';
import { AttachmentModel } from '../../../../shared/models/attachment.model';
import MediaAttachmentsPreview from '../../../../shared/components/MediaAttachmentsPreview.vue';
import { parentTypes } from '../../../../shared/enums/parentTypes';

export default defineComponent({
  name: 'EventDetailsAttachments',
  components: { MediaAttachmentsPreview },
  props: {
    attachments: { type: Array as PropType<AttachmentModel[]>, required: true },
  },
  emits: ['open'],
  setup(_, { emit }) {
    const emitOpen = (data: unknown): void => {
      emit('open', data);
    };

    return {
      emitOpen,
      parentTypes,
    };
  },
});
